// sort-imports-ignore

/*
 *
 * This file was generated by GraphQL Codegen.
 * Do not modify it.
 *
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
/** An enumeration. */
export enum AiReportRejectionReason {
  BadBiopsySlide = "BAD_BIOPSY_SLIDE",
  BadClinicalVariables = "BAD_CLINICAL_VARIABLES",
  BadExternalId = "BAD_EXTERNAL_ID",
  InsufficientTumor = "INSUFFICIENT_TUMOR",
  NoCancerDetected = "NO_CANCER_DETECTED",
  Other = "OTHER",
  RescanRequired = "RESCAN_REQUIRED",
  WrongSlide = "WRONG_SLIDE",
}

/** This is the current status for the FaxesModel. */
export enum ArteraFaxStatus {
  Canceled = "CANCELED",
  Failure = "FAILURE",
  Pending = "PENDING",
  Success = "SUCCESS",
}

export enum BiologicalSex {
  Female = "FEMALE",
  Male = "MALE",
  Other = "OTHER",
}

/** An enumeration. */
export enum BlockId {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
  G = "G",
  H = "H",
  I = "I",
  J = "J",
  K = "K",
  L = "L",
  M = "M",
  N = "N",
  O = "O",
  P = "P",
  Q = "Q",
  R = "R",
  S = "S",
  T = "T",
  U = "U",
  V = "V",
  W = "W",
  X = "X",
  Y = "Y",
  Z = "Z",
}

export type CancelMultiPartUploadInput = {
  uploadedFileId: string;
};

export type CreateAddressInput = {
  city?: string | null | undefined;
  country?: string | null | undefined;
  state?: string | null | undefined;
  streetAddress1?: string | null | undefined;
  streetAddress2?: string | null | undefined;
  zipCode?: string | null | undefined;
};

export type CreateOrderInput = {
  customMetastaticDiagnosisCode?: string | null | undefined;
  customPrimaryDiagnosisCode?: string | null | undefined;
  externalId?: string | null | undefined;
  labId?: string | null | undefined;
  labProcedureDate?: string | null | undefined;
  metastaticDiagnosisCodes?:
    | Array<MetastaticDiagnosisCode | null | undefined>
    | null
    | undefined;
  nStage?: NStage | null | undefined;
  nccnRiskCategory?: NccnRiskCategory | null | undefined;
  orderingPathway: OrderingPathway;
  orderingProviderId?: string | null | undefined;
  patient?: CreatePatientInput | null | undefined;
  patientAge?: number | null | undefined;
  patientDischargeDate?: string | null | undefined;
  patientLabAccession?: string | null | undefined;
  patientStatusAtBiopsy?: PatientStatusAtBiopsy | null | undefined;
  positiveCores?: number | null | undefined;
  primaryDiagnosisCodes?:
    | Array<PrimaryDiagnosisCode | null | undefined>
    | null
    | undefined;
  primaryGleasonScore?: number | null | undefined;
  psa?: number | null | undefined;
  secondaryGleasonScore?: number | null | undefined;
  siteId?: string | null | undefined;
  slideSamplePart?: string | null | undefined;
  specimenType: SpecimenType;
  startedAt: string;
  surgicalMargin?: SurgicalMargin | null | undefined;
  tStage?: TStage | null | undefined;
  totalCores?: number | null | undefined;
  tumorSize?: number | null | undefined;
  yearOfBirth?: number | null | undefined;
};

export type CreateOrderingPhysicianInput = {
  email?: string | null | undefined;
  externalId?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  middleInitial?: string | null | undefined;
  npi?: string | null | undefined;
};

export type CreateOrderingProviderInput = {
  orderingPhysician: CreateOrderingPhysicianInput;
  receiveReportsByFax?: boolean | null | undefined;
  siteAddress?: CreateAddressInput | null | undefined;
  siteFaxNumber?: string | null | undefined;
  siteFaxRegionCode?: string | null | undefined;
  siteName?: string | null | undefined;
};

export type CreatePatientAddressInput = {
  cityPhi?: string | null | undefined;
  country?: string | null | undefined;
  state?: string | null | undefined;
  streetAddress1Phi?: string | null | undefined;
  streetAddress2Phi?: string | null | undefined;
  zipCodePhi?: string | null | undefined;
};

export type CreatePatientInput = {
  address?: CreatePatientAddressInput | null | undefined;
  biologicalSex?: BiologicalSex | null | undefined;
  biologicalSexExplanation?: string | null | undefined;
  dateOfBirthPhi?: string | null | undefined;
  email?: string | null | undefined;
  ethnicity?: Ethnicity | null | undefined;
  firstNamePhi?: string | null | undefined;
  lastNamePhi?: string | null | undefined;
  medicalRecordNumberPhi?: string | null | undefined;
  middleInitialPhi?: string | null | undefined;
  phoneNumber?: string | null | undefined;
  phoneRegionCode?: string | null | undefined;
};

/** An enumeration. */
export enum DownloadReportErrorCode {
  InvalidOrderStatus = "INVALID_ORDER_STATUS",
  ReportNotAvailable = "REPORT_NOT_AVAILABLE",
}

export enum Ethnicity {
  AmericanIndianOrAlaskaNative = "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
  Asian = "ASIAN",
  BlackOrAfricanAmerican = "BLACK_OR_AFRICAN_AMERICAN",
  HispanicOrLatino = "HISPANIC_OR_LATINO",
  NativeHawaiianOrOtherPacificIslander = "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER",
  Other = "OTHER",
  White = "WHITE",
}

/** Enum for the type of fax. */
export enum FaxType {
  BillingFiles = "BILLING_FILES",
  PathologyFiles = "PATHOLOGY_FILES",
  TestReportOrderingProvider = "TEST_REPORT_ORDERING_PROVIDER",
  TestReportPathologyLab = "TEST_REPORT_PATHOLOGY_LAB",
}

/** An enumeration. */
export enum LabType {
  AncillaryLab = "ANCILLARY_LAB",
  ArteraLab = "ARTERA_LAB",
  DirectUploadLab = "DIRECT_UPLOAD_LAB",
}

export enum MetastaticDiagnosisCode {
  C79_51 = "C79_51",
}

/** Clinical fields specific to metastatic prostate biopsy revisions. */
export type MetastaticProstateBiopsyRevisionData = {
  psa: number;
  tStage: TStage;
};

export enum NccnRiskCategory {
  High = "HIGH",
  IntermediateFavorable = "INTERMEDIATE_FAVORABLE",
  IntermediateUnfavorable = "INTERMEDIATE_UNFAVORABLE",
  Low = "LOW",
  NotProvided = "NOT_PROVIDED",
  VeryHigh = "VERY_HIGH",
  VeryLow = "VERY_LOW",
}

export enum NStage {
  N0 = "N0",
  N1 = "N1",
  N1_2 = "N1_2",
  N2 = "N2",
  N2_3 = "N2_3",
  N3 = "N3",
}

/** An enumeration. */
export enum OrderStatus {
  AiError = "AI_ERROR",
  AiProcessing = "AI_PROCESSING",
  Canceled = "CANCELED",
  Deleted = "DELETED",
  Draft = "DRAFT",
  LabError = "LAB_ERROR",
  LabProcessing = "LAB_PROCESSING",
  PathologyFaxFailed = "PATHOLOGY_FAX_FAILED",
  PathologyFaxPending = "PATHOLOGY_FAX_PENDING",
  QualityControlApproved = "QUALITY_CONTROL_APPROVED",
  QualityControlPending = "QUALITY_CONTROL_PENDING",
  ReportFaxed = "REPORT_FAXED",
  ReportFaxFailed = "REPORT_FAX_FAILED",
  ReportFaxPending = "REPORT_FAX_PENDING",
  ReportPending = "REPORT_PENDING",
  ReportReady = "REPORT_READY",
  ReportRejected = "REPORT_REJECTED",
  ReportSigned = "REPORT_SIGNED",
  SlideImageProcessing = "SLIDE_IMAGE_PROCESSING",
  SlideImageQualityControlFailed = "SLIDE_IMAGE_QUALITY_CONTROL_FAILED",
  SlideImageQualityControlPending = "SLIDE_IMAGE_QUALITY_CONTROL_PENDING",
}

/** An enumeration. */
export enum OrderingPathway {
  CustomTrfNonReflexive = "CUSTOM_TRF_NON_REFLEXIVE",
  DefaultNonReflexive = "DEFAULT_NON_REFLEXIVE",
  OtherFormReflexive = "OTHER_FORM_REFLEXIVE",
  StickerTrfNonReflexive = "STICKER_TRF_NON_REFLEXIVE",
  StickerTrfReflexive = "STICKER_TRF_REFLEXIVE",
}

/** How the organization orders and delivers slide images to Artera. */
export enum OrganizationWorkflowType {
  AncillaryLab = "ANCILLARY_LAB",
  Clinic = "CLINIC",
  DirectUploadLab = "DIRECT_UPLOAD_LAB",
  Tempus = "TEMPUS",
}

/** An enumeration. */
export enum PathologyFaxAction {
  FaxPathologyFiles = "FAX_PATHOLOGY_FILES",
  SkipFaxGenerateFiles = "SKIP_FAX_GENERATE_FILES",
  SkipFaxNoFiles = "SKIP_FAX_NO_FILES",
}

/** An enumeration. */
export enum PathologyLabType {
  Ancillary = "ANCILLARY",
  DirectUpload = "DIRECT_UPLOAD",
  Opd = "OPD",
}

export enum PatientStatusAtBiopsy {
  HospitalInpatient = "HOSPITAL_INPATIENT",
  HospitalOutpatient = "HOSPITAL_OUTPATIENT",
  NonHospitalOutpatient = "NON_HOSPITAL_OUTPATIENT",
  NotProvided = "NOT_PROVIDED",
}

export enum PrimaryDiagnosisCode {
  C61 = "C61",
}

/** Clinical fields specific to prostate biopsy specimen revisions. */
export type ProstateBiopsyRevisionData = {
  nccnRiskCategory: NccnRiskCategory;
  positiveCores?: number | null | undefined;
  primaryGleasonScore: number;
  psa: number;
  secondaryGleasonScore: number;
  tStage: TStage;
  totalCores?: number | null | undefined;
};

/** Clinical fields specific to prostate post-RP specimen revisions. */
export type ProstatePostRpRevisionData = {
  primaryGleasonScore: number;
  psa: number;
  secondaryGleasonScore: number;
  surgicalMargin: SurgicalMargin;
  tStage: TStage;
};

export type ResubmitOrderInput = {
  externalId: string;
  id: string;
  labId?: string | null | undefined;
  nStage?: NStage | null | undefined;
  nccnRiskCategory?: NccnRiskCategory | null | undefined;
  patient?: CreatePatientInput | null | undefined;
  patientAge: number;
  primaryGleasonScore?: number | null | undefined;
  psa?: number | null | undefined;
  secondaryGleasonScore?: number | null | undefined;
  siteId?: string | null | undefined;
  specimenType: SpecimenType;
  surgicalMargin?: SurgicalMargin | null | undefined;
  tStage?: TStage | null | undefined;
  tumorSize?: number | null | undefined;
  yearOfBirth?: number | null | undefined;
};

export type ReviseReportInput = {
  labProcedureDatePhi: string;
  metastaticProstateData?:
    | MetastaticProstateBiopsyRevisionData
    | null
    | undefined;
  orderId: string;
  orderingProviderId: string;
  patientDateOfBirthPhi: string;
  patientEthnicity?: Ethnicity | null | undefined;
  patientFirstNamePhi: string;
  patientLastNamePhi: string;
  prostateBiopsyData?: ProstateBiopsyRevisionData | null | undefined;
  prostatePostRpData?: ProstatePostRpRevisionData | null | undefined;
  reason: string;
  specimenId?: string | null | undefined;
};

export enum Seq {
  Asc = "ASC",
  Desc = "DESC",
}

export type SetOrderPathologyLabInput = {
  id: string;
  pathologyLabSalesforceId: string;
};

/** An enumeration. */
export enum SlideImageScannerType {
  GrundiumOcus_20 = "GRUNDIUM_OCUS_20",
  HamamatsuNanozoomerS360 = "HAMAMATSU_NANOZOOMER_S360",
  HamamatsuNanozoomerS360Md = "HAMAMATSU_NANOZOOMER_S360MD",
  KfbioPro = "KFBIO_PRO",
  LeicaGt450Dx = "LEICA_GT450_DX",
  PhilipsUltraFast = "PHILIPS_ULTRA_FAST",
  ThreeDHistechP1000 = "THREE_D_HISTECH_P1000",
}

export type SlideMetadataInputType = {
  /** Accession number (E.g. ART-24-1234) */
  accession: string;
  /** Block ID - single uppercase letter (A-Z). This field is optional */
  blockId?: BlockId | null | undefined;
  /** Specimen ID (E.g. S12345) */
  specimenId: string;
  /** E.g. SlideSite.LEFT_MID, or SlideSite.OTHER */
  specimenSite: SlideSite;
  /** Human-readable label for the specimen site. E.g. what is displayed when the site name is OTHER. */
  specimenSiteLabel?: string | null | undefined;
};

/** An enumeration. */
export enum SlideSite {
  LeftAnterolateralAnteromedial = "LEFT_ANTEROLATERAL_ANTEROMEDIAL",
  LeftApex = "LEFT_APEX",
  LeftBase = "LEFT_BASE",
  LeftLateralApex = "LEFT_LATERAL_APEX",
  LeftLateralBase = "LEFT_LATERAL_BASE",
  LeftLateralMid = "LEFT_LATERAL_MID",
  LeftMid = "LEFT_MID",
  LeftPeripheralZone = "LEFT_PERIPHERAL_ZONE",
  LeftPosteriorLateral = "LEFT_POSTERIOR_LATERAL",
  LeftPosteriorMedial = "LEFT_POSTERIOR_MEDIAL",
  LeftTransitionZone = "LEFT_TRANSITION_ZONE",
  Other = "OTHER",
  RightAnterolateralAnteromedial = "RIGHT_ANTEROLATERAL_ANTEROMEDIAL",
  RightApex = "RIGHT_APEX",
  RightBase = "RIGHT_BASE",
  RightLateralApex = "RIGHT_LATERAL_APEX",
  RightLateralBase = "RIGHT_LATERAL_BASE",
  RightLateralMid = "RIGHT_LATERAL_MID",
  RightMid = "RIGHT_MID",
  RightPeripheralZone = "RIGHT_PERIPHERAL_ZONE",
  RightPosteriorLateral = "RIGHT_POSTERIOR_LATERAL",
  RightPosteriorMedial = "RIGHT_POSTERIOR_MEDIAL",
  RightTransitionZone = "RIGHT_TRANSITION_ZONE",
}

export enum SortBy {
  Status = "STATUS",
  StatusUpdatedAt = "STATUS_UPDATED_AT",
  SubmittedAt = "SUBMITTED_AT",
}

/** An enumeration. */
export enum SpecimenType {
  BreastBiopsy = "BREAST_BIOPSY",
  ColorectalCancer = "COLORECTAL_CANCER",
  MetastaticProstateBiopsy = "METASTATIC_PROSTATE_BIOPSY",
  ProstateBiopsy = "PROSTATE_BIOPSY",
  ProstatePostRp = "PROSTATE_POST_RP",
}

export type SubmitOrderInput = {
  consentToBillPatient?: boolean | null | undefined;
  customMetastaticDiagnosisCode?: string | null | undefined;
  customPrimaryDiagnosisCode?: string | null | undefined;
  externalId: string;
  id: string;
  labId?: string | null | undefined;
  labProcedureDate?: string | null | undefined;
  metastaticDiagnosisCodes?:
    | Array<MetastaticDiagnosisCode | null | undefined>
    | null
    | undefined;
  nStage?: NStage | null | undefined;
  nccnRiskCategory?: NccnRiskCategory | null | undefined;
  /** For CS to document why they update a Lumea Ancillary order */
  notes?: string | null | undefined;
  orderingProviderId?: string | null | undefined;
  patient?: CreatePatientInput | null | undefined;
  patientAge: number;
  patientDischargeDate?: string | null | undefined;
  patientLabAccession?: string | null | undefined;
  patientStatusAtBiopsy?: PatientStatusAtBiopsy | null | undefined;
  positiveCores?: number | null | undefined;
  primaryDiagnosisCodes?:
    | Array<PrimaryDiagnosisCode | null | undefined>
    | null
    | undefined;
  primaryGleasonScore?: number | null | undefined;
  psa?: number | null | undefined;
  /** Reason for revising an order during QC */
  qcRevisionReason?: string | null | undefined;
  secondaryGleasonScore?: number | null | undefined;
  siteId?: string | null | undefined;
  slideSamplePart?: string | null | undefined;
  specimenType: SpecimenType;
  surgicalMargin?: SurgicalMargin | null | undefined;
  tStage?: TStage | null | undefined;
  totalCores?: number | null | undefined;
  tumorSize?: number | null | undefined;
  /** IDs of files uploaded by the user to document why they update an order during QC */
  uploadedFileIds?: Array<string | null | undefined> | null | undefined;
  yearOfBirth?: number | null | undefined;
};

export enum SurgicalMargin {
  Negative = "NEGATIVE",
  Positive = "POSITIVE",
}

export enum TStage {
  NotProvided = "NOT_PROVIDED",
  T1A = "T1A",
  T1B = "T1B",
  T1C = "T1C",
  T2 = "T2",
  T2A = "T2A",
  T2B = "T2B",
  T2C = "T2C",
  T3 = "T3",
  T3A = "T3A",
  T3B = "T3B",
  T4 = "T4",
}

export type UpdateOrderBillingHoldInput = {
  hasBillingHold: boolean;
  id: string;
};

export type UpdateOrderInput = {
  consentToBillPatient?: boolean | null | undefined;
  customMetastaticDiagnosisCode?: string | null | undefined;
  customPrimaryDiagnosisCode?: string | null | undefined;
  externalId?: string | null | undefined;
  id: string;
  labId?: string | null | undefined;
  labProcedureDate?: string | null | undefined;
  metastaticDiagnosisCodes?:
    | Array<MetastaticDiagnosisCode | null | undefined>
    | null
    | undefined;
  nStage?: NStage | null | undefined;
  nccnRiskCategory?: NccnRiskCategory | null | undefined;
  /** For CS to document why they update a Lumea Ancillary order */
  notes?: string | null | undefined;
  orderingProviderId?: string | null | undefined;
  patient?: CreatePatientInput | null | undefined;
  patientAge?: number | null | undefined;
  patientDischargeDate?: string | null | undefined;
  patientLabAccession?: string | null | undefined;
  patientStatusAtBiopsy?: PatientStatusAtBiopsy | null | undefined;
  positiveCores?: number | null | undefined;
  primaryDiagnosisCodes?:
    | Array<PrimaryDiagnosisCode | null | undefined>
    | null
    | undefined;
  primaryGleasonScore?: number | null | undefined;
  psa?: number | null | undefined;
  /** Reason for revising an order during QC */
  qcRevisionReason?: string | null | undefined;
  secondaryGleasonScore?: number | null | undefined;
  /** Required when updating a Tempus order in QC Pending with missing/invalid clinical variables. If true, email Tempus and advance the order to QC Approved. If false, the order is saved without a status change. */
  sendTempusMissingClinicalVariablesEmail?: boolean | null | undefined;
  siteId?: string | null | undefined;
  slideSamplePart?: string | null | undefined;
  specimenType: SpecimenType;
  surgicalMargin?: SurgicalMargin | null | undefined;
  tStage?: TStage | null | undefined;
  totalCores?: number | null | undefined;
  tumorSize?: number | null | undefined;
  /** IDs of files uploaded by the user to document why they update an order during QC */
  uploadedFileIds?: Array<string | null | undefined> | null | undefined;
  yearOfBirth?: number | null | undefined;
};

export type UpdateOrderingProviderInput = {
  id: string;
  orderingPhysician?: CreateOrderingPhysicianInput | null | undefined;
  receiveReportsByFax?: boolean | null | undefined;
  siteAddress?: CreateAddressInput | null | undefined;
  siteFaxNumber?: string | null | undefined;
  siteFaxRegionCode?: string | null | undefined;
  siteName?: string | null | undefined;
};

export type UpdateRejectedOrderInput = {
  consentToBillPatient?: boolean | null | undefined;
  customMetastaticDiagnosisCode?: string | null | undefined;
  customPrimaryDiagnosisCode?: string | null | undefined;
  id?: string | null | undefined;
  labProcedureDate?: string | null | undefined;
  metastaticDiagnosisCodes?:
    | Array<MetastaticDiagnosisCode | null | undefined>
    | null
    | undefined;
  nccnRiskCategory?: NccnRiskCategory | null | undefined;
  /** For CS to document why they update a Lumea Ancillary order */
  notes?: string | null | undefined;
  orderingProviderId?: string | null | undefined;
  patient?: CreatePatientInput | null | undefined;
  patientAge?: number | null | undefined;
  patientDischargeDate?: string | null | undefined;
  patientLabAccession?: string | null | undefined;
  patientStatusAtBiopsy?: PatientStatusAtBiopsy | null | undefined;
  positiveCores?: number | null | undefined;
  primaryDiagnosisCodes?:
    | Array<PrimaryDiagnosisCode | null | undefined>
    | null
    | undefined;
  primaryGleasonScore?: number | null | undefined;
  psa?: number | null | undefined;
  /** Reason for revising an order during QC */
  qcRevisionReason?: string | null | undefined;
  secondaryGleasonScore?: number | null | undefined;
  slideSamplePart?: string | null | undefined;
  specimenType?: SpecimenType | null | undefined;
  surgicalMargin?: SurgicalMargin | null | undefined;
  tStage?: TStage | null | undefined;
  totalCores?: number | null | undefined;
  /** IDs of files uploaded by the user to document why they update an order during QC */
  uploadedFileIds?: Array<string | null | undefined> | null | undefined;
};

/** An enumeration. */
export enum UploadedFileCategory {
  AiReport = "AI_REPORT",
  Attestation = "ATTESTATION",
  CancelDoc = "CANCEL_DOC",
  ConsultReport = "CONSULT_REPORT",
  FaceSheet = "FACE_SHEET",
  Insurance = "INSURANCE",
  MedicalNote = "MEDICAL_NOTE",
  Other = "OTHER",
  PathologyReport = "PATHOLOGY_REPORT",
  PsaReport = "PSA_REPORT",
  RecentOfficeNote = "RECENT_OFFICE_NOTE",
  SlideImage = "SLIDE_IMAGE",
  TestRequisitionForm = "TEST_REQUISITION_FORM",
}

/** An enumeration. */
export enum UploadedFileStatus {
  Complete = "COMPLETE",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
}

export type EffectiveOrganizationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EffectiveOrganizationQuery = {
  auth0: {
    effectiveOrganization: {
      id: string;
      name: string | null;
      displayName: string | null;
      workflowType: OrganizationWorkflowType;
      features: { isInternational: boolean; allowTStageNotProvided: boolean };
    };
  };
};

export type UploadedFileFieldsFragment = {
  id: string;
  filename: string;
  category: UploadedFileCategory;
  status: UploadedFileStatus | null;
  progress: number | null;
  createdAt: string | null;
  uploaderAuth0Id: string | null;
};

export type UploadedFileConnectionFieldsFragment = {
  edges: Array<{
    node: {
      id: string;
      filename: string;
      category: UploadedFileCategory;
      status: UploadedFileStatus | null;
      progress: number | null;
      createdAt: string | null;
      uploaderAuth0Id: string | null;
    } | null;
  } | null>;
};

export type ActivityLogFieldsFragment = {
  id: string;
  action: string | null;
  createdAt: string | null;
  details: string | null;
  principalId: string | null;
  principalName: string | null;
  resourceId: string | null;
  resourceType: string | null;
  updatedAt: string | null;
};

export type RoleFieldsFragment = {
  id: string;
  name: string;
  description: string;
};

export type InvitationFieldsFragment = {
  id: string;
  email: string;
  createdAt: string;
  expiresAt: string;
  inviterName: string;
  organizationId: string;
  roles: Array<{ id: string; name: string; description: string }>;
};

export type UserFieldsFragment = {
  userId: string;
  email: string;
  name: string | null;
  givenName: string | null;
  familyName: string | null;
  phoneNumber: string | null;
  picture: string | null;
  roles: Array<{ id: string; name: string; description: string }>;
  lab: { id: string; name: string } | null;
  sites: Array<{ id: string; name: string } | null> | null;
};

export type OrganizationFieldsFragment = {
  id: string;
  name: string | null;
  displayName: string | null;
  workflowType: OrganizationWorkflowType;
  features: { isInternational: boolean; allowTStageNotProvided: boolean };
};

export type OrganizationListFieldsFragment = {
  id: string;
  name: string | null;
  displayName: string | null;
  workflowType: OrganizationWorkflowType;
};

export type PatientBaseFieldsFragment = {
  firstNamePhi: string | null;
  lastNamePhi: string | null;
  dateOfBirthPhi: string | null;
};

export type OrderBaseFieldsFragment = {
  id: string;
  crossOrgId: string;
  createdAt: string | null;
  updatedAt: string | null;
  submittedAt: string | null;
  statusUpdatedAt: string | null;
  creatorAuth0Id: string | null;
  status: OrderStatus;
  externalId: string | null;
  specimenType: SpecimenType;
  nccnRiskCategory: NccnRiskCategory | null;
  primaryGleasonScore: number | null;
  secondaryGleasonScore: number | null;
  psa: number | null;
  tStage: TStage | null;
  surgicalMargin: SurgicalMargin | null;
  statusMessage: string | null;
  patient: {
    firstNamePhi: string | null;
    lastNamePhi: string | null;
    dateOfBirthPhi: string | null;
  } | null;
  uploadedFiles: {
    edges: Array<{
      node: {
        id: string;
        filename: string;
        category: UploadedFileCategory;
        status: UploadedFileStatus | null;
        progress: number | null;
        createdAt: string | null;
        uploaderAuth0Id: string | null;
      } | null;
    } | null>;
  } | null;
};

export type GetAssignableRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAssignableRolesQuery = {
  auth0: {
    assignableRoles: Array<{ id: string; name: string; description: string }>;
  };
};

export type GetInvitationsQueryVariables = Exact<{
  page?: number | null | undefined;
  perPage?: number | null | undefined;
}>;

export type GetInvitationsQuery = {
  auth0: {
    invitations: {
      page: number;
      totalCount: number | null;
      items: Array<{
        id: string;
        email: string;
        createdAt: string;
        expiresAt: string;
        inviterName: string;
        organizationId: string;
        roles: Array<{ id: string; name: string; description: string }>;
      }>;
    };
  };
};

export type GetMembersQueryVariables = Exact<{
  page?: number | null | undefined;
  perPage?: number | null | undefined;
}>;

export type GetMembersQuery = {
  auth0: {
    users: {
      page: number;
      totalCount: number | null;
      items: Array<{
        userId: string;
        email: string;
        name: string | null;
        givenName: string | null;
        familyName: string | null;
        phoneNumber: string | null;
        picture: string | null;
        roles: Array<{ id: string; name: string; description: string }>;
        lab: { id: string; name: string } | null;
        sites: Array<{ id: string; name: string } | null> | null;
      }>;
    };
  };
};

export type InviteUserMutationVariables = Exact<{
  email: string;
  roleIds: Array<string | null | undefined> | string;
}>;

export type InviteUserMutation = {
  inviteUser: {
    invitation: {
      id: string;
      email: string;
      createdAt: string;
      expiresAt: string;
      inviterName: string;
      organizationId: string;
      roles: Array<{ id: string; name: string; description: string }>;
    } | null;
  } | null;
};

export type RemoveInvitationMutationVariables = Exact<{
  inviteId: string;
}>;

export type RemoveInvitationMutation = {
  removeInvitation: { inviteId: string } | null;
};

export type ReplaceRolesMutationVariables = Exact<{
  userId: string;
  roleIds: Array<string | null | undefined> | string;
}>;

export type ReplaceRolesMutation = {
  replaceRoles: { roleIds: Array<string | null> } | null;
};

export type RemoveUsersMutationVariables = Exact<{
  userIds: Array<string | null | undefined> | string;
}>;

export type RemoveUsersMutation = {
  removeUsers: { userIds: Array<string | null> } | null;
};

export type DeleteOrderMutationVariables = Exact<{
  id: string;
}>;

export type DeleteOrderMutation = {
  deleteOrder: { order: { id: string } | null } | null;
};

export type CancelOrderMutationVariables = Exact<{
  id: string;
}>;

export type CancelOrderMutation = {
  cancelOrder: {
    order: {
      id: string;
      status: OrderStatus;
      statusUpdatedAt: string | null;
    } | null;
  } | null;
};

export type ActivityLogQueryVariables = Exact<{
  resourceId: string;
  resourceType: string;
}>;

export type ActivityLogQuery = {
  activityLog: {
    edges: Array<{
      node: {
        id: string;
        action: string | null;
        createdAt: string | null;
        details: string | null;
        principalId: string | null;
        principalName: string | null;
        resourceId: string | null;
        resourceType: string | null;
        updatedAt: string | null;
      } | null;
    } | null>;
  } | null;
};

export type CancelMultipartUploadMutationVariables = Exact<{
  input: CancelMultiPartUploadInput;
}>;

export type CancelMultipartUploadMutation = {
  cancelMultipartUpload: {
    order: {
      id: string;
      uploadedFiles: {
        edges: Array<{
          node: {
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
    };
  } | null;
};

export type OrganizationsQueryVariables = Exact<{ [key: string]: never }>;

export type OrganizationsQuery = {
  auth0: {
    organizations: Array<{
      id: string;
      name: string | null;
      displayName: string | null;
      workflowType: OrganizationWorkflowType;
    }>;
  };
};

export type LdtUploadedFileFieldsFragment = {
  isAutoGenerated: boolean;
  id: string;
  filename: string;
  category: UploadedFileCategory;
  status: UploadedFileStatus | null;
  progress: number | null;
  createdAt: string | null;
  uploaderAuth0Id: string | null;
};

export type LdtUploadedFileConnectionFieldsFragment = {
  edges: Array<{
    node: {
      isAutoGenerated: boolean;
      id: string;
      filename: string;
      category: UploadedFileCategory;
      status: UploadedFileStatus | null;
      progress: number | null;
      createdAt: string | null;
      uploaderAuth0Id: string | null;
    } | null;
  } | null>;
};

export type OrderingPhysicianFieldsFragment = {
  firstName: string | null;
  lastName: string | null;
  npi: string | null;
  email: string | null;
};

export type OrderingPhysicianNameFieldsFragment = {
  firstName: string | null;
  lastName: string | null;
};

export type OrderingProviderFieldsFragment = {
  id: string;
  siteName: string | null;
  siteFaxRegionCode: string | null;
  siteFaxNumber: string | null;
  receiveReportsByFax: boolean | null;
  orderingPhysician: {
    firstName: string | null;
    lastName: string | null;
    npi: string | null;
    email: string | null;
  } | null;
};

export type OrderingProviderListFieldsFragment = {
  orderingPhysician: {
    firstName: string | null;
    lastName: string | null;
  } | null;
};

export type PathologyLabFieldsFragment = {
  id: string;
  type: PathologyLabType | null;
  name: string;
  email: string | null;
  phoneNumber: string | null;
  faxNumber: string | null;
  street: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
  country: string | null;
  skipFax: boolean;
};

export type PatientFieldsFragment = {
  middleInitialPhi: string | null;
  ethnicity: Ethnicity | null;
  firstNamePhi: string | null;
  lastNamePhi: string | null;
  dateOfBirthPhi: string | null;
};

export type OrderSlideMetadataFieldsFragment = {
  accession: string | null;
  siteLabel: string | null;
  blockId: BlockId | null;
};

export type FaxFieldsFragment = {
  status: ArteraFaxStatus | null;
  selectedFiles: Array<{ id: string } | null> | null;
};

export type LdtOrderListItemFieldsFragment = {
  id: string;
  createdByCs: boolean;
  specimenType: SpecimenType;
  status: OrderStatus;
  crossOrgId: string;
  externalId: string | null;
  organizationName: string;
  createdAt: string | null;
  updatedAt: string | null;
  submittedAt: string | null;
  needsAttention?: boolean;
  patient: {
    middleInitialPhi: string | null;
    ethnicity: Ethnicity | null;
    firstNamePhi: string | null;
    lastNamePhi: string | null;
    dateOfBirthPhi: string | null;
  } | null;
  orderingProvider: {
    orderingPhysician: {
      firstName: string | null;
      lastName: string | null;
    } | null;
  } | null;
};

export type LdtOrderDetailFieldsFragment = {
  createdByCs: boolean;
  orderingPathway: OrderingPathway;
  positiveCores: number | null;
  totalCores: number | null;
  patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
  patientDischargeDate: string | null;
  primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
  customPrimaryDiagnosisCode: string | null;
  metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
  customMetastaticDiagnosisCode: string | null;
  consentToBillPatient: boolean | null;
  trfS3Url: string | null;
  hasRevisedReport: boolean;
  hasAiReport: boolean;
  hasBillingHold: boolean;
  labProcedureDatePhi: string | null;
  qcRevisionReason: string | null;
  slideSamplePart: string | null;
  patientLabAccession: string | null;
  imageQcRejectionReason: string | null;
  specimenId: string | null;
  bxlinkAccession: string | null;
  bxlinkEncounterId: string | null;
  organizationName: string;
  labType: LabType;
  id: string;
  crossOrgId: string;
  createdAt: string | null;
  updatedAt: string | null;
  submittedAt: string | null;
  statusUpdatedAt: string | null;
  creatorAuth0Id: string | null;
  status: OrderStatus;
  externalId: string | null;
  specimenType: SpecimenType;
  nccnRiskCategory: NccnRiskCategory | null;
  primaryGleasonScore: number | null;
  secondaryGleasonScore: number | null;
  psa: number | null;
  tStage: TStage | null;
  surgicalMargin: SurgicalMargin | null;
  statusMessage: string | null;
  uploadedFiles: {
    edges: Array<{
      node: {
        isAutoGenerated: boolean;
        id: string;
        filename: string;
        category: UploadedFileCategory;
        status: UploadedFileStatus | null;
        progress: number | null;
        createdAt: string | null;
        uploaderAuth0Id: string | null;
      } | null;
    } | null>;
  } | null;
  mostRecentPathologyTrrFax: {
    status: ArteraFaxStatus | null;
    selectedFiles: Array<{ id: string } | null> | null;
  } | null;
  patient: {
    middleInitialPhi: string | null;
    ethnicity: Ethnicity | null;
    firstNamePhi: string | null;
    lastNamePhi: string | null;
    dateOfBirthPhi: string | null;
  } | null;
  orderingProvider: {
    id: string;
    siteName: string | null;
    siteFaxRegionCode: string | null;
    siteFaxNumber: string | null;
    receiveReportsByFax: boolean | null;
    orderingPhysician: {
      firstName: string | null;
      lastName: string | null;
      npi: string | null;
      email: string | null;
    } | null;
  } | null;
  pathologyLab: {
    id: string;
    type: PathologyLabType | null;
    name: string;
    email: string | null;
    phoneNumber: string | null;
    faxNumber: string | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
    skipFax: boolean;
  } | null;
};

export type LdtOrderDetailDirectUploadLabTechFieldsFragment = {
  createdByCs: boolean;
  orderingPathway: OrderingPathway;
  positiveCores: number | null;
  totalCores: number | null;
  patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
  patientDischargeDate: string | null;
  primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
  customPrimaryDiagnosisCode: string | null;
  metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
  customMetastaticDiagnosisCode: string | null;
  consentToBillPatient: boolean | null;
  trfS3Url: string | null;
  hasRevisedReport: boolean;
  hasAiReport: boolean;
  hasBillingHold: boolean;
  labProcedureDatePhi: string | null;
  qcRevisionReason: string | null;
  slideSamplePart: string | null;
  patientLabAccession: string | null;
  imageQcRejectionReason: string | null;
  specimenId: string | null;
  bxlinkAccession: string | null;
  bxlinkEncounterId: string | null;
  organizationName: string;
  labType: LabType;
  id: string;
  crossOrgId: string;
  createdAt: string | null;
  updatedAt: string | null;
  submittedAt: string | null;
  statusUpdatedAt: string | null;
  creatorAuth0Id: string | null;
  status: OrderStatus;
  externalId: string | null;
  specimenType: SpecimenType;
  nccnRiskCategory: NccnRiskCategory | null;
  primaryGleasonScore: number | null;
  secondaryGleasonScore: number | null;
  psa: number | null;
  tStage: TStage | null;
  surgicalMargin: SurgicalMargin | null;
  statusMessage: string | null;
  slide: {
    accession: string | null;
    siteLabel: string | null;
    blockId: BlockId | null;
  } | null;
  uploadedFiles: {
    edges: Array<{
      node: {
        isAutoGenerated: boolean;
        id: string;
        filename: string;
        category: UploadedFileCategory;
        status: UploadedFileStatus | null;
        progress: number | null;
        createdAt: string | null;
        uploaderAuth0Id: string | null;
      } | null;
    } | null>;
  } | null;
  mostRecentPathologyTrrFax: {
    status: ArteraFaxStatus | null;
    selectedFiles: Array<{ id: string } | null> | null;
  } | null;
  patient: {
    middleInitialPhi: string | null;
    ethnicity: Ethnicity | null;
    firstNamePhi: string | null;
    lastNamePhi: string | null;
    dateOfBirthPhi: string | null;
  } | null;
  orderingProvider: {
    id: string;
    siteName: string | null;
    siteFaxRegionCode: string | null;
    siteFaxNumber: string | null;
    receiveReportsByFax: boolean | null;
    orderingPhysician: {
      firstName: string | null;
      lastName: string | null;
      npi: string | null;
      email: string | null;
    } | null;
  } | null;
  pathologyLab: {
    id: string;
    type: PathologyLabType | null;
    name: string;
    email: string | null;
    phoneNumber: string | null;
    faxNumber: string | null;
    street: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
    skipFax: boolean;
  } | null;
};

export type LdtOrderForReviseReportFieldsFragment = {
  id: string;
  crossOrgId: string;
  specimenType: SpecimenType;
  status: OrderStatus;
  specimenId: string | null;
  psa: number | null;
  tStage: TStage | null;
  nccnRiskCategory: NccnRiskCategory | null;
  primaryGleasonScore: number | null;
  secondaryGleasonScore: number | null;
  totalCores: number | null;
  positiveCores: number | null;
  surgicalMargin: SurgicalMargin | null;
  labProcedureDatePhi: string | null;
  patient: {
    middleInitialPhi: string | null;
    ethnicity: Ethnicity | null;
    firstNamePhi: string | null;
    lastNamePhi: string | null;
    dateOfBirthPhi: string | null;
  } | null;
  orderingProvider: {
    id: string;
    siteName: string | null;
    siteFaxRegionCode: string | null;
    siteFaxNumber: string | null;
    receiveReportsByFax: boolean | null;
    orderingPhysician: {
      firstName: string | null;
      lastName: string | null;
      npi: string | null;
      email: string | null;
    } | null;
  } | null;
};

export type LdtOrdersQueryVariables = Exact<{
  page: number;
  perPage: number;
  searchText?: string | null | undefined;
  sortBy?: SortBy | null | undefined;
  seq?: Seq | null | undefined;
  statuses?:
    | Array<OrderStatus | null | undefined>
    | OrderStatus
    | null
    | undefined;
  specimenTypes?:
    | Array<SpecimenType | null | undefined>
    | SpecimenType
    | null
    | undefined;
  needsAttentionFirst?: boolean | null | undefined;
  includeNeedsAttention?: boolean;
}>;

export type LdtOrdersQuery = {
  orders: {
    page: number | null;
    totalCount: number | null;
    items: Array<{
      id: string;
      createdByCs: boolean;
      specimenType: SpecimenType;
      status: OrderStatus;
      crossOrgId: string;
      externalId: string | null;
      organizationName: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      needsAttention?: boolean;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type LdtOrderQueryVariables = Exact<{
  orderId: string;
}>;

export type LdtOrderQuery = {
  order: {
    createdByCs: boolean;
    orderingPathway: OrderingPathway;
    positiveCores: number | null;
    totalCores: number | null;
    patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
    patientDischargeDate: string | null;
    primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
    customPrimaryDiagnosisCode: string | null;
    metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
    customMetastaticDiagnosisCode: string | null;
    consentToBillPatient: boolean | null;
    trfS3Url: string | null;
    hasRevisedReport: boolean;
    hasAiReport: boolean;
    hasBillingHold: boolean;
    labProcedureDatePhi: string | null;
    qcRevisionReason: string | null;
    slideSamplePart: string | null;
    patientLabAccession: string | null;
    imageQcRejectionReason: string | null;
    specimenId: string | null;
    bxlinkAccession: string | null;
    bxlinkEncounterId: string | null;
    organizationName: string;
    labType: LabType;
    id: string;
    crossOrgId: string;
    createdAt: string | null;
    updatedAt: string | null;
    submittedAt: string | null;
    statusUpdatedAt: string | null;
    creatorAuth0Id: string | null;
    status: OrderStatus;
    externalId: string | null;
    specimenType: SpecimenType;
    nccnRiskCategory: NccnRiskCategory | null;
    primaryGleasonScore: number | null;
    secondaryGleasonScore: number | null;
    psa: number | null;
    tStage: TStage | null;
    surgicalMargin: SurgicalMargin | null;
    statusMessage: string | null;
    uploadedFiles: {
      edges: Array<{
        node: {
          isAutoGenerated: boolean;
          id: string;
          filename: string;
          category: UploadedFileCategory;
          status: UploadedFileStatus | null;
          progress: number | null;
          createdAt: string | null;
          uploaderAuth0Id: string | null;
        } | null;
      } | null>;
    } | null;
    mostRecentPathologyTrrFax: {
      status: ArteraFaxStatus | null;
      selectedFiles: Array<{ id: string } | null> | null;
    } | null;
    patient: {
      middleInitialPhi: string | null;
      ethnicity: Ethnicity | null;
      firstNamePhi: string | null;
      lastNamePhi: string | null;
      dateOfBirthPhi: string | null;
    } | null;
    orderingProvider: {
      id: string;
      siteName: string | null;
      siteFaxRegionCode: string | null;
      siteFaxNumber: string | null;
      receiveReportsByFax: boolean | null;
      orderingPhysician: {
        firstName: string | null;
        lastName: string | null;
        npi: string | null;
        email: string | null;
      } | null;
    } | null;
    pathologyLab: {
      id: string;
      type: PathologyLabType | null;
      name: string;
      email: string | null;
      phoneNumber: string | null;
      faxNumber: string | null;
      street: string | null;
      city: string | null;
      state: string | null;
      zipCode: string | null;
      country: string | null;
      skipFax: boolean;
    } | null;
  } | null;
};

export type LdtOrderDirectUploadLabTechQueryVariables = Exact<{
  orderId: string;
}>;

export type LdtOrderDirectUploadLabTechQuery = {
  order: {
    createdByCs: boolean;
    orderingPathway: OrderingPathway;
    positiveCores: number | null;
    totalCores: number | null;
    patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
    patientDischargeDate: string | null;
    primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
    customPrimaryDiagnosisCode: string | null;
    metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
    customMetastaticDiagnosisCode: string | null;
    consentToBillPatient: boolean | null;
    trfS3Url: string | null;
    hasRevisedReport: boolean;
    hasAiReport: boolean;
    hasBillingHold: boolean;
    labProcedureDatePhi: string | null;
    qcRevisionReason: string | null;
    slideSamplePart: string | null;
    patientLabAccession: string | null;
    imageQcRejectionReason: string | null;
    specimenId: string | null;
    bxlinkAccession: string | null;
    bxlinkEncounterId: string | null;
    organizationName: string;
    labType: LabType;
    id: string;
    crossOrgId: string;
    createdAt: string | null;
    updatedAt: string | null;
    submittedAt: string | null;
    statusUpdatedAt: string | null;
    creatorAuth0Id: string | null;
    status: OrderStatus;
    externalId: string | null;
    specimenType: SpecimenType;
    nccnRiskCategory: NccnRiskCategory | null;
    primaryGleasonScore: number | null;
    secondaryGleasonScore: number | null;
    psa: number | null;
    tStage: TStage | null;
    surgicalMargin: SurgicalMargin | null;
    statusMessage: string | null;
    slide: {
      accession: string | null;
      siteLabel: string | null;
      blockId: BlockId | null;
    } | null;
    uploadedFiles: {
      edges: Array<{
        node: {
          isAutoGenerated: boolean;
          id: string;
          filename: string;
          category: UploadedFileCategory;
          status: UploadedFileStatus | null;
          progress: number | null;
          createdAt: string | null;
          uploaderAuth0Id: string | null;
        } | null;
      } | null>;
    } | null;
    mostRecentPathologyTrrFax: {
      status: ArteraFaxStatus | null;
      selectedFiles: Array<{ id: string } | null> | null;
    } | null;
    patient: {
      middleInitialPhi: string | null;
      ethnicity: Ethnicity | null;
      firstNamePhi: string | null;
      lastNamePhi: string | null;
      dateOfBirthPhi: string | null;
    } | null;
    orderingProvider: {
      id: string;
      siteName: string | null;
      siteFaxRegionCode: string | null;
      siteFaxNumber: string | null;
      receiveReportsByFax: boolean | null;
      orderingPhysician: {
        firstName: string | null;
        lastName: string | null;
        npi: string | null;
        email: string | null;
      } | null;
    } | null;
    pathologyLab: {
      id: string;
      type: PathologyLabType | null;
      name: string;
      email: string | null;
      phoneNumber: string | null;
      faxNumber: string | null;
      street: string | null;
      city: string | null;
      state: string | null;
      zipCode: string | null;
      country: string | null;
      skipFax: boolean;
    } | null;
  } | null;
};

export type UpdateOrderBillingHoldMutationVariables = Exact<{
  input: UpdateOrderBillingHoldInput;
}>;

export type UpdateOrderBillingHoldMutation = {
  updateOrderBillingHold: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type CreateLdtOrderMutationVariables = Exact<{
  order: CreateOrderInput;
}>;

export type CreateLdtOrderMutation = {
  createOrder: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type UpdateLdtOrderMutationVariables = Exact<{
  order: UpdateOrderInput;
}>;

export type UpdateLdtOrderMutation = {
  updateOrder: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type UpdateRejectedOrderMutationVariables = Exact<{
  input?: UpdateRejectedOrderInput | null | undefined;
  newStatus?: OrderStatus | null | undefined;
}>;

export type UpdateRejectedOrderMutation = {
  updateRejectedOrder: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type SubmitLdtOrderMutationVariables = Exact<{
  input: SubmitOrderInput;
}>;

export type SubmitLdtOrderMutation = {
  submitOrder: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type LdtOrderingProvidersQueryVariables = Exact<{
  searchText?: string | null | undefined;
  after?: string | null | undefined;
  first?: number | null | undefined;
}>;

export type LdtOrderingProvidersQuery = {
  orderingProviders: {
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string | null;
      endCursor: string | null;
    };
    edges: Array<{
      cursor: string;
      node: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
    } | null>;
  } | null;
};

export type CreateOrderingProviderMutationVariables = Exact<{
  input: CreateOrderingProviderInput;
}>;

export type CreateOrderingProviderMutation = {
  createOrderingProvider: {
    orderingProvider: {
      id: string;
      siteName: string | null;
      siteFaxRegionCode: string | null;
      siteFaxNumber: string | null;
      receiveReportsByFax: boolean | null;
      orderingPhysician: {
        firstName: string | null;
        lastName: string | null;
        npi: string | null;
        email: string | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateOrderingProviderMutationVariables = Exact<{
  input: UpdateOrderingProviderInput;
}>;

export type UpdateOrderingProviderMutation = {
  updateOrderingProvider: {
    orderingProvider: {
      id: string;
      siteName: string | null;
      siteFaxRegionCode: string | null;
      siteFaxNumber: string | null;
      receiveReportsByFax: boolean | null;
      orderingPhysician: {
        firstName: string | null;
        lastName: string | null;
        npi: string | null;
        email: string | null;
      } | null;
    } | null;
  } | null;
};

export type DeleteOrderingProviderMutationVariables = Exact<{
  id: string;
}>;

export type DeleteOrderingProviderMutation = {
  deleteOrderingProvider: { orderingProvider: { id: string } | null } | null;
};

export type DeleteLdtFileMutationVariables = Exact<{
  id: string;
}>;

export type DeleteLdtFileMutation = {
  deleteFile: { deletedFile: { id: string } | null } | null;
};

export type IsValidOrderingPhysicianEmailQueryVariables = Exact<{
  email: string;
}>;

export type IsValidOrderingPhysicianEmailQuery = {
  isValidOrderingPhysicianEmail: {
    isValid: boolean;
    isAlreadyUsed: boolean;
  } | null;
};

export type PathologyLabsQueryVariables = Exact<{
  siteName?: string | null | undefined;
  after?: string | null | undefined;
  first?: number | null | undefined;
}>;

export type PathologyLabsQuery = {
  salesforce: {
    pathologyLabs: {
      pageInfo: {
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string | null;
        endCursor: string | null;
      };
      edges: Array<{
        cursor: string;
        node: {
          id: string;
          type: PathologyLabType | null;
          name: string;
          email: string | null;
          phoneNumber: string | null;
          faxNumber: string | null;
          street: string | null;
          city: string | null;
          state: string | null;
          zipCode: string | null;
          country: string | null;
          skipFax: boolean;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type SetOrderPathologyLabMutationVariables = Exact<{
  input: SetOrderPathologyLabInput;
}>;

export type SetOrderPathologyLabMutation = {
  setOrderPathologyLab: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type FileDownloadUrlQueryVariables = Exact<{
  id: string;
}>;

export type FileDownloadUrlQuery = { fileDownloadUrl: string | null };

export type CreateLdtMultipartUploadMutationVariables = Exact<{
  filename: string;
  category: UploadedFileCategory;
  orderId: string;
  countParts: number;
  scannerType?: SlideImageScannerType | null | undefined;
  slideMetadata?: SlideMetadataInputType | null | undefined;
}>;

export type CreateLdtMultipartUploadMutation = {
  createMultipartUpload: { uploadedFile: { id: string } } | null;
};

export type UpdateOrderStatusQcApprovedMutationVariables = Exact<{
  id: string;
  note?: string | null | undefined;
  pathologyFaxAction?: PathologyFaxAction | null | undefined;
  uploadedFileIds?: Array<string> | string | null | undefined;
}>;

export type UpdateOrderStatusQcApprovedMutation = {
  updateOrderStatusQCApproved: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type RefaxPathologyFilesMutationVariables = Exact<{
  orderId?: string | null | undefined;
  note?: string | null | undefined;
  pathologyFaxAction: PathologyFaxAction;
  uploadedFileIds?: Array<string> | string | null | undefined;
}>;

export type RefaxPathologyFilesMutation = {
  refaxPathologyFiles: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type UpdateOrderStatusMutationVariables = Exact<{
  id: string;
  status: OrderStatus;
}>;

export type UpdateOrderStatusMutation = {
  updateOrderStatus: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type QcApproveSlideImageMutationVariables = Exact<{
  orderId: string;
}>;

export type QcApproveSlideImageMutation = {
  qcApproveSlideImage: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type QcRejectSlideImageMutationVariables = Exact<{
  orderId: string;
  reason: string;
}>;

export type QcRejectSlideImageMutation = {
  qcRejectSlideImage: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type FaxTestReportToPathologyLabMutationVariables = Exact<{
  orderId: string;
}>;

export type FaxTestReportToPathologyLabMutation = {
  faxTestReportToPathologyLab: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type FaxTestReportToOrderingProviderMutationVariables = Exact<{
  orderId: string;
}>;

export type FaxTestReportToOrderingProviderMutation = {
  faxTestReportToOrderingProvider: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type ShareTrrMutationVariables = Exact<{
  id: string;
  emails: Array<string> | string;
}>;

export type ShareTrrMutation = {
  shareTrr: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type LdtOrderForReviseReportQueryVariables = Exact<{
  orderId: string;
}>;

export type LdtOrderForReviseReportQuery = {
  order: {
    id: string;
    crossOrgId: string;
    specimenType: SpecimenType;
    status: OrderStatus;
    specimenId: string | null;
    psa: number | null;
    tStage: TStage | null;
    nccnRiskCategory: NccnRiskCategory | null;
    primaryGleasonScore: number | null;
    secondaryGleasonScore: number | null;
    totalCores: number | null;
    positiveCores: number | null;
    surgicalMargin: SurgicalMargin | null;
    labProcedureDatePhi: string | null;
    patient: {
      middleInitialPhi: string | null;
      ethnicity: Ethnicity | null;
      firstNamePhi: string | null;
      lastNamePhi: string | null;
      dateOfBirthPhi: string | null;
    } | null;
    orderingProvider: {
      id: string;
      siteName: string | null;
      siteFaxRegionCode: string | null;
      siteFaxNumber: string | null;
      receiveReportsByFax: boolean | null;
      orderingPhysician: {
        firstName: string | null;
        lastName: string | null;
        npi: string | null;
        email: string | null;
      } | null;
    } | null;
  } | null;
};

export type DownloadTestReportQueryVariables = Exact<{
  id: string;
  deidentified?: boolean | null | undefined;
}>;

export type DownloadTestReportQuery = {
  downloadTestReport: { finalReportUrl: string | null } | null;
};

export type ReviseReportMutationVariables = Exact<{
  input: ReviseReportInput;
}>;

export type ReviseReportMutation = {
  reviseReport: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type MostRecentFaxQueryVariables = Exact<{
  orderId: string;
  faxType: FaxType;
}>;

export type MostRecentFaxQuery = {
  mostRecentFax: {
    status: ArteraFaxStatus | null;
    selectedFiles: Array<{ id: string } | null> | null;
  } | null;
};

export type LdtRejectReportMutationVariables = Exact<{
  orderId: string;
  reason: string;
  newStatus?: OrderStatus | null | undefined;
}>;

export type LdtRejectReportMutation = {
  ldtRejectReport: {
    order: {
      createdByCs: boolean;
      orderingPathway: OrderingPathway;
      positiveCores: number | null;
      totalCores: number | null;
      patientStatusAtBiopsy: PatientStatusAtBiopsy | null;
      patientDischargeDate: string | null;
      primaryDiagnosisCodes: Array<PrimaryDiagnosisCode | null> | null;
      customPrimaryDiagnosisCode: string | null;
      metastaticDiagnosisCodes: Array<MetastaticDiagnosisCode | null> | null;
      customMetastaticDiagnosisCode: string | null;
      consentToBillPatient: boolean | null;
      trfS3Url: string | null;
      hasRevisedReport: boolean;
      hasAiReport: boolean;
      hasBillingHold: boolean;
      labProcedureDatePhi: string | null;
      qcRevisionReason: string | null;
      slideSamplePart: string | null;
      patientLabAccession: string | null;
      imageQcRejectionReason: string | null;
      specimenId: string | null;
      bxlinkAccession: string | null;
      bxlinkEncounterId: string | null;
      organizationName: string;
      labType: LabType;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            isAutoGenerated: boolean;
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
      mostRecentPathologyTrrFax: {
        status: ArteraFaxStatus | null;
        selectedFiles: Array<{ id: string } | null> | null;
      } | null;
      patient: {
        middleInitialPhi: string | null;
        ethnicity: Ethnicity | null;
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      orderingProvider: {
        id: string;
        siteName: string | null;
        siteFaxRegionCode: string | null;
        siteFaxNumber: string | null;
        receiveReportsByFax: boolean | null;
        orderingPhysician: {
          firstName: string | null;
          lastName: string | null;
          npi: string | null;
          email: string | null;
        } | null;
      } | null;
      pathologyLab: {
        id: string;
        type: PathologyLabType | null;
        name: string;
        email: string | null;
        phoneNumber: string | null;
        faxNumber: string | null;
        street: string | null;
        city: string | null;
        state: string | null;
        zipCode: string | null;
        country: string | null;
        skipFax: boolean;
      } | null;
    } | null;
  } | null;
};

export type BuildVersionsQueryVariables = Exact<{ [key: string]: never }>;

export type BuildVersionsQuery = {
  buildVersions: {
    ui: string;
    backend: string;
    slidePreprocessor: string;
    aiExecutor: string;
    prostatePrognosticModel: string | null;
    breastPrognosticModel: string | null;
    prostateSTADTModel: string | null;
  };
};

export type BuildVersionsFieldsFragment = {
  ui: string;
  backend: string;
  slidePreprocessor: string;
  aiExecutor: string;
  prostatePrognosticModel: string | null;
  breastPrognosticModel: string | null;
  prostateSTADTModel: string | null;
};

export type SamdOrderListItemFieldsFragment = {
  id: string;
  specimenType: SpecimenType;
  externalId: string | null;
  status: OrderStatus;
  crossOrgId: string;
  updatedAt: string | null;
  submittedAt: string | null;
};

export type SamdOrderDetailFieldsFragment = {
  nStage: NStage | null;
  tumorSize: number | null;
  patientAge: number | null;
  reportRejectionReason: AiReportRejectionReason | null;
  reportCustomRejectionReason: string | null;
  id: string;
  crossOrgId: string;
  createdAt: string | null;
  updatedAt: string | null;
  submittedAt: string | null;
  statusUpdatedAt: string | null;
  creatorAuth0Id: string | null;
  status: OrderStatus;
  externalId: string | null;
  specimenType: SpecimenType;
  nccnRiskCategory: NccnRiskCategory | null;
  primaryGleasonScore: number | null;
  secondaryGleasonScore: number | null;
  psa: number | null;
  tStage: TStage | null;
  surgicalMargin: SurgicalMargin | null;
  statusMessage: string | null;
  patient: {
    firstNamePhi: string | null;
    lastNamePhi: string | null;
    dateOfBirthPhi: string | null;
  } | null;
  uploadedFiles: {
    edges: Array<{
      node: {
        id: string;
        filename: string;
        category: UploadedFileCategory;
        status: UploadedFileStatus | null;
        progress: number | null;
        createdAt: string | null;
        uploaderAuth0Id: string | null;
      } | null;
    } | null>;
  } | null;
};

export type SamdOrdersQueryVariables = Exact<{
  page: number;
  perPage: number;
  searchText?: string | null | undefined;
  sortBy?: SortBy | null | undefined;
  seq?: Seq | null | undefined;
  statuses?:
    | Array<OrderStatus | null | undefined>
    | OrderStatus
    | null
    | undefined;
  specimenTypes?:
    | Array<SpecimenType | null | undefined>
    | SpecimenType
    | null
    | undefined;
}>;

export type SamdOrdersQuery = {
  orders: {
    page: number | null;
    totalCount: number | null;
    items: Array<{
      id: string;
      specimenType: SpecimenType;
      externalId: string | null;
      status: OrderStatus;
      crossOrgId: string;
      updatedAt: string | null;
      submittedAt: string | null;
    } | null> | null;
  } | null;
};

export type SamdOrderQueryVariables = Exact<{
  orderId: string;
}>;

export type SamdOrderQuery = {
  order: {
    nStage: NStage | null;
    tumorSize: number | null;
    patientAge: number | null;
    reportRejectionReason: AiReportRejectionReason | null;
    reportCustomRejectionReason: string | null;
    id: string;
    crossOrgId: string;
    createdAt: string | null;
    updatedAt: string | null;
    submittedAt: string | null;
    statusUpdatedAt: string | null;
    creatorAuth0Id: string | null;
    status: OrderStatus;
    externalId: string | null;
    specimenType: SpecimenType;
    nccnRiskCategory: NccnRiskCategory | null;
    primaryGleasonScore: number | null;
    secondaryGleasonScore: number | null;
    psa: number | null;
    tStage: TStage | null;
    surgicalMargin: SurgicalMargin | null;
    statusMessage: string | null;
    patient: {
      firstNamePhi: string | null;
      lastNamePhi: string | null;
      dateOfBirthPhi: string | null;
    } | null;
    uploadedFiles: {
      edges: Array<{
        node: {
          id: string;
          filename: string;
          category: UploadedFileCategory;
          status: UploadedFileStatus | null;
          progress: number | null;
          createdAt: string | null;
          uploaderAuth0Id: string | null;
        } | null;
      } | null>;
    } | null;
  } | null;
};

export type CreateSamdOrderMutationVariables = Exact<{
  order: CreateOrderInput;
}>;

export type CreateSamdOrderMutation = {
  createOrder: {
    order: {
      nStage: NStage | null;
      tumorSize: number | null;
      patientAge: number | null;
      reportRejectionReason: AiReportRejectionReason | null;
      reportCustomRejectionReason: string | null;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      patient: {
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type UpdateSamdOrderMutationVariables = Exact<{
  order: UpdateOrderInput;
}>;

export type UpdateSamdOrderMutation = {
  updateOrder: {
    order: {
      nStage: NStage | null;
      tumorSize: number | null;
      patientAge: number | null;
      reportRejectionReason: AiReportRejectionReason | null;
      reportCustomRejectionReason: string | null;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      patient: {
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type SubmitSamdOrderMutationVariables = Exact<{
  input: SubmitOrderInput;
}>;

export type SubmitSamdOrderMutation = {
  submitOrder: {
    order: {
      nStage: NStage | null;
      tumorSize: number | null;
      patientAge: number | null;
      reportRejectionReason: AiReportRejectionReason | null;
      reportCustomRejectionReason: string | null;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      patient: {
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type ResubmitSamdOrderMutationVariables = Exact<{
  input: ResubmitOrderInput;
}>;

export type ResubmitSamdOrderMutation = {
  resubmitOrder: {
    order: {
      nStage: NStage | null;
      tumorSize: number | null;
      patientAge: number | null;
      reportRejectionReason: AiReportRejectionReason | null;
      reportCustomRejectionReason: string | null;
      id: string;
      crossOrgId: string;
      createdAt: string | null;
      updatedAt: string | null;
      submittedAt: string | null;
      statusUpdatedAt: string | null;
      creatorAuth0Id: string | null;
      status: OrderStatus;
      externalId: string | null;
      specimenType: SpecimenType;
      nccnRiskCategory: NccnRiskCategory | null;
      primaryGleasonScore: number | null;
      secondaryGleasonScore: number | null;
      psa: number | null;
      tStage: TStage | null;
      surgicalMargin: SurgicalMargin | null;
      statusMessage: string | null;
      patient: {
        firstNamePhi: string | null;
        lastNamePhi: string | null;
        dateOfBirthPhi: string | null;
      } | null;
      uploadedFiles: {
        edges: Array<{
          node: {
            id: string;
            filename: string;
            category: UploadedFileCategory;
            status: UploadedFileStatus | null;
            progress: number | null;
            createdAt: string | null;
            uploaderAuth0Id: string | null;
          } | null;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type DeleteSamdOrderMutationVariables = Exact<{
  id: string;
}>;

export type DeleteSamdOrderMutation = {
  deleteOrder: { order: { id: string } | null } | null;
};

export type DownloadTrrQueryVariables = Exact<{
  id: string;
  signed: boolean;
}>;

export type DownloadTrrQuery = {
  downloadTRR:
    | { __typename: "DownloadReportError"; code: DownloadReportErrorCode }
    | { __typename: "TestResultReport"; presignedUrl: string };
};

export type DownloadSlideImageQueryVariables = Exact<{
  id: string;
}>;

export type DownloadSlideImageQuery = { fileDownloadUrl: string | null };

export type DownloadClinicalDecisionSupportQueryVariables = Exact<{
  id: string;
}>;

export type DownloadClinicalDecisionSupportQuery = {
  downloadClinicalDecisionSupport:
    | { __typename: "ClinicalDecisionSupport"; presignedUrl: string }
    | { __typename: "DownloadReportError"; code: DownloadReportErrorCode };
};

export type DownloadCombinedReportQueryVariables = Exact<{
  id: string;
}>;

export type DownloadCombinedReportQuery = {
  downloadCombinedReport:
    | { __typename: "CombinedReport"; presignedUrl: string }
    | { __typename: "DownloadReportError"; code: DownloadReportErrorCode };
};

export type CreateSamdMultipartUploadMutationVariables = Exact<{
  filename: string;
  category: UploadedFileCategory;
  orderId: string;
  countParts: number;
  scannerType?: SlideImageScannerType | null | undefined;
}>;

export type CreateSamdMultipartUploadMutation = {
  createMultipartUpload: { uploadedFile: { id: string } } | null;
};

export const ActivityLogFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityLogFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ActivityLog" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "principalId" } },
          { kind: "Field", name: { kind: "Name", value: "principalName" } },
          { kind: "Field", name: { kind: "Name", value: "resourceId" } },
          { kind: "Field", name: { kind: "Name", value: "resourceType" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityLogFieldsFragment, unknown>;
export const RoleFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RoleFieldsFragment, unknown>;
export const InvitationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InvitationFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invitation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "inviterName" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoleFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InvitationFieldsFragment, unknown>;
export const UserFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "picture" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoleFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFieldsFragment, unknown>;
export const OrganizationFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "workflowType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isInternational" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowTStageNotProvided" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationFieldsFragment, unknown>;
export const OrganizationListFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationListFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "workflowType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationListFieldsFragment, unknown>;
export const PatientBaseFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientBaseFieldsFragment, unknown>;
export const PatientFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PatientFieldsFragment, unknown>;
export const OrderingPhysicianNameFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianNameFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderingPhysicianNameFieldsFragment, unknown>;
export const OrderingProviderListFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderListFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianNameFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianNameFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderingProviderListFieldsFragment, unknown>;
export const LdtOrderListItemFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderListItemFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderListFields" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "needsAttention" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeNeedsAttention" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianNameFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderListFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianNameFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtOrderListItemFieldsFragment, unknown>;
export const UploadedFileFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadedFileFieldsFragment, unknown>;
export const UploadedFileConnectionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadedFileConnectionFieldsFragment, unknown>;
export const OrderBaseFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderBaseFieldsFragment, unknown>;
export const LdtUploadedFileFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtUploadedFileFieldsFragment, unknown>;
export const LdtUploadedFileConnectionFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtUploadedFileConnectionFieldsFragment, unknown>;
export const FaxFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FaxFieldsFragment, unknown>;
export const OrderingPhysicianFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderingPhysicianFieldsFragment, unknown>;
export const OrderingProviderFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderingProviderFieldsFragment, unknown>;
export const PathologyLabFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PathologyLabFieldsFragment, unknown>;
export const LdtOrderDetailFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtOrderDetailFieldsFragment, unknown>;
export const OrderSlideMetadataFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderSlideMetadataFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderSlideMetadata" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accession" } },
          { kind: "Field", name: { kind: "Name", value: "siteLabel" } },
          { kind: "Field", name: { kind: "Name", value: "blockId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrderSlideMetadataFieldsFragment, unknown>;
export const LdtOrderDetailDirectUploadLabTechFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailDirectUploadLabTechFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "LdtOrderDetailFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slide" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderSlideMetadataFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderSlideMetadataFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderSlideMetadata" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accession" } },
          { kind: "Field", name: { kind: "Name", value: "siteLabel" } },
          { kind: "Field", name: { kind: "Name", value: "blockId" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LdtOrderDetailDirectUploadLabTechFieldsFragment,
  unknown
>;
export const LdtOrderForReviseReportFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderForReviseReportFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtOrderForReviseReportFieldsFragment, unknown>;
export const BuildVersionsFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BuildVersionsFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BuildVersions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "ui" } },
          { kind: "Field", name: { kind: "Name", value: "backend" } },
          { kind: "Field", name: { kind: "Name", value: "slidePreprocessor" } },
          { kind: "Field", name: { kind: "Name", value: "aiExecutor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "prostatePrognosticModel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "breastPrognosticModel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "prostateSTADTModel" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildVersionsFieldsFragment, unknown>;
export const SamdOrderListItemFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderListItemFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SamdOrderListItemFieldsFragment, unknown>;
export const SamdOrderDetailFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "nStage" } },
          { kind: "Field", name: { kind: "Name", value: "tumorSize" } },
          { kind: "Field", name: { kind: "Name", value: "patientAge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRejectionReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportCustomRejectionReason" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SamdOrderDetailFieldsFragment, unknown>;
export const EffectiveOrganizationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "EffectiveOrganization" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auth0" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "effectiveOrganization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OrganizationFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "workflowType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "features" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isInternational" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "allowTStageNotProvided" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EffectiveOrganizationQuery,
  EffectiveOrganizationQueryVariables
>;
export const GetAssignableRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAssignableRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auth0" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignableRoles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "RoleFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAssignableRolesQuery,
  GetAssignableRolesQueryVariables
>;
export const GetInvitationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInvitations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "perPage" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auth0" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitations" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "perPage" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "perPage" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "InvitationFields" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InvitationFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invitation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "inviterName" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoleFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const GetMembersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMembers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "perPage" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auth0" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "users" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "page" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "page" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "perPage" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "perPage" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "UserFields" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "page" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "userId" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "givenName" } },
          { kind: "Field", name: { kind: "Name", value: "familyName" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "picture" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoleFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "lab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "sites" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMembersQuery, GetMembersQueryVariables>;
export const InviteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "InviteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortString" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roleIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ShortString" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inviteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roleIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "InvitationFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RoleFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Role" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "InvitationFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Invitation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
          { kind: "Field", name: { kind: "Name", value: "inviterName" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "roles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RoleFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InviteUserMutation, InviteUserMutationVariables>;
export const RemoveInvitationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveInvitation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortString" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeInvitation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "inviteId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveInvitationMutation,
  RemoveInvitationMutationVariables
>;
export const ReplaceRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReplaceRoles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortString" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "roleIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ShortString" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "replaceRoles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "roleIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "roleIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "roleIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReplaceRolesMutation,
  ReplaceRolesMutationVariables
>;
export const RemoveUsersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RemoveUsers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "userIds" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ShortString" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "removeUsers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "userIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "userIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "userIds" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveUsersMutation, RemoveUsersMutationVariables>;
export const DeleteOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const CancelOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusUpdatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const ActivityLogDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ActivityLog" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resourceId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resourceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activityLog" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "resourceId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "resourceId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "resourceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "resourceType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ActivityLogFields",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ActivityLogFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ActivityLog" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "action" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "details" } },
          { kind: "Field", name: { kind: "Name", value: "principalId" } },
          { kind: "Field", name: { kind: "Name", value: "principalName" } },
          { kind: "Field", name: { kind: "Name", value: "resourceId" } },
          { kind: "Field", name: { kind: "Name", value: "resourceType" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityLogQuery, ActivityLogQueryVariables>;
export const CancelMultipartUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelMultipartUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CancelMultiPartUploadInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelMultipartUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "uploadedFiles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "UploadedFileConnectionFields",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CancelMultipartUploadMutation,
  CancelMultipartUploadMutationVariables
>;
export const OrganizationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Organizations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auth0" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organizations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OrganizationListFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationListFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "workflowType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationsQuery, OrganizationsQueryVariables>;
export const LdtOrdersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LdtOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "perPage" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchText" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ShortString" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortBy" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "seq" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Seq" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrderStatus" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "specimenTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpecimenType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "needsAttentionFirst" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "includeNeedsAttention" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "perPage" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "perPage" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchText" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchText" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "seq" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "seq" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "specimenTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "specimenTypes" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "needsAttentionFirst" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "needsAttentionFirst" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "page" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderListItemFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianNameFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderListFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianNameFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderListItemFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderListFields" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "needsAttention" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "includeNeedsAttention" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtOrdersQuery, LdtOrdersQueryVariables>;
export const LdtOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LdtOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "order" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "LdtOrderDetailFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LdtOrderQuery, LdtOrderQueryVariables>;
export const LdtOrderDirectUploadLabTechDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LdtOrderDirectUploadLabTech" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "order" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtOrderDetailDirectUploadLabTechFields",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderSlideMetadataFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderSlideMetadata" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "accession" } },
          { kind: "Field", name: { kind: "Name", value: "siteLabel" } },
          { kind: "Field", name: { kind: "Name", value: "blockId" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailDirectUploadLabTechFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "LdtOrderDetailFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slide" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderSlideMetadataFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LdtOrderDirectUploadLabTechQuery,
  LdtOrderDirectUploadLabTechQueryVariables
>;
export const UpdateOrderBillingHoldDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrderBillingHold" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateOrderBillingHoldInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrderBillingHold" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrderBillingHoldMutation,
  UpdateOrderBillingHoldMutationVariables
>;
export const CreateLdtOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateLdtOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "order" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "order" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateLdtOrderMutation,
  CreateLdtOrderMutationVariables
>;
export const UpdateLdtOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateLdtOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "order" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "order" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLdtOrderMutation,
  UpdateLdtOrderMutationVariables
>;
export const UpdateRejectedOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateRejectedOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "UpdateRejectedOrderInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OrderStatus" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateRejectedOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newStatus" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "newStatus" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateRejectedOrderMutation,
  UpdateRejectedOrderMutationVariables
>;
export const SubmitLdtOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitLdtOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SubmitOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitLdtOrderMutation,
  SubmitLdtOrderMutationVariables
>;
export const LdtOrderingProvidersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LdtOrderingProviders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchText" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ShortString" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "first" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          defaultValue: { kind: "IntValue", value: "15" },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProviders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchText" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchText" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "after" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "first" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasNextPage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasPreviousPage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startCursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endCursor" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "OrderingProviderFields",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LdtOrderingProvidersQuery,
  LdtOrderingProvidersQueryVariables
>;
export const CreateOrderingProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateOrderingProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrderingProviderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrderingProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orderingProvider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OrderingProviderFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateOrderingProviderMutation,
  CreateOrderingProviderMutationVariables
>;
export const UpdateOrderingProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrderingProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateOrderingProviderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrderingProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orderingProvider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "OrderingProviderFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrderingProviderMutation,
  UpdateOrderingProviderMutationVariables
>;
export const DeleteOrderingProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteOrderingProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOrderingProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "orderingProvider" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOrderingProviderMutation,
  DeleteOrderingProviderMutationVariables
>;
export const DeleteLdtFileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteLdtFile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteFile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deletedFile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteLdtFileMutation,
  DeleteLdtFileMutationVariables
>;
export const IsValidOrderingPhysicianEmailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsValidOrderingPhysicianEmail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortString" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isValidOrderingPhysicianEmail" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isValid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isAlreadyUsed" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IsValidOrderingPhysicianEmailQuery,
  IsValidOrderingPhysicianEmailQueryVariables
>;
export const PathologyLabsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PathologyLabs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "siteName" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ShortString" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "first" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "salesforce" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pathologyLabs" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "siteName" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "siteName" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "after" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "first" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasNextPage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasPreviousPage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startCursor" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endCursor" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cursor" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "PathologyLabFields",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PathologyLabsQuery, PathologyLabsQueryVariables>;
export const SetOrderPathologyLabDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetOrderPathologyLab" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SetOrderPathologyLabInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setOrderPathologyLab" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetOrderPathologyLabMutation,
  SetOrderPathologyLabMutationVariables
>;
export const FileDownloadUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "FileDownloadUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fileDownloadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FileDownloadUrlQuery,
  FileDownloadUrlQueryVariables
>;
export const CreateLdtMultipartUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateLdtMultipartUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filename" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UploadedFileCategory" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countParts" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scannerType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SlideImageScannerType" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "slideMetadata" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SlideMetadataInputType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createMultipartUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "filename" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "filename" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "orderId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orderId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "countParts" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "countParts" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "scannerType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "scannerType" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "slideMetadata" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "slideMetadata" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "uploadedFile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateLdtMultipartUploadMutation,
  CreateLdtMultipartUploadMutationVariables
>;
export const UpdateOrderStatusQcApprovedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrderStatusQCApproved" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pathologyFaxAction" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PathologyFaxAction" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "uploadedFileIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrderStatusQCApproved" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathologyFaxAction" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pathologyFaxAction" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadedFileIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uploadedFileIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrderStatusQcApprovedMutation,
  UpdateOrderStatusQcApprovedMutationVariables
>;
export const RefaxPathologyFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RefaxPathologyFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "note" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pathologyFaxAction" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PathologyFaxAction" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "uploadedFileIds" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refaxPathologyFiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "note" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "note" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pathologyFaxAction" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pathologyFaxAction" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "uploadedFileIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uploadedFileIds" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefaxPathologyFilesMutation,
  RefaxPathologyFilesMutationVariables
>;
export const UpdateOrderStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOrderStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrderStatus" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrderStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateOrderStatusMutation,
  UpdateOrderStatusMutationVariables
>;
export const QcApproveSlideImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "QcApproveSlideImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "qcApproveSlideImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QcApproveSlideImageMutation,
  QcApproveSlideImageMutationVariables
>;
export const QcRejectSlideImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "QcRejectSlideImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reason" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "qcRejectSlideImage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reason" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QcRejectSlideImageMutation,
  QcRejectSlideImageMutationVariables
>;
export const FaxTestReportToPathologyLabDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FaxTestReportToPathologyLab" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "faxTestReportToPathologyLab" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FaxTestReportToPathologyLabMutation,
  FaxTestReportToPathologyLabMutationVariables
>;
export const FaxTestReportToOrderingProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FaxTestReportToOrderingProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "faxTestReportToOrderingProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FaxTestReportToOrderingProviderMutation,
  FaxTestReportToOrderingProviderMutationVariables
>;
export const ShareTrrDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ShareTrr" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emails" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ShortString" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shareTrr" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "emails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emails" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShareTrrMutation, ShareTrrMutationVariables>;
export const LdtOrderForReviseReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LdtOrderForReviseReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "order" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtOrderForReviseReportFields",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderForReviseReportFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LdtOrderForReviseReportQuery,
  LdtOrderForReviseReportQueryVariables
>;
export const DownloadTestReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadTestReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deidentified" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadTestReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deidentified" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deidentified" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "finalReportUrl" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadTestReportQuery,
  DownloadTestReportQueryVariables
>;
export const ReviseReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReviseReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReviseReportInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reviseReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReviseReportMutation,
  ReviseReportMutationVariables
>;
export const MostRecentFaxDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MostRecentFax" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "faxType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FaxType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentFax" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "faxType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "faxType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MostRecentFaxQuery, MostRecentFaxQueryVariables>;
export const LdtRejectReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LdtRejectReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "reason" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ShortString" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newStatus" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OrderStatus" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "ldtRejectReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "orderId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "reason" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "reason" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "newStatus" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "newStatus" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "UploadedFileFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "isAutoGenerated" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtUploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "LdtUploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FaxFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Fax" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "selectedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "PatientBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "middleInitialPhi" } },
          { kind: "Field", name: { kind: "Name", value: "ethnicity" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingPhysicianFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingPhysician" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "npi" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderingProviderFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "OrderingProvider" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "siteName" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxRegionCode" } },
          { kind: "Field", name: { kind: "Name", value: "siteFaxNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "receiveReportsByFax" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingPhysician" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingPhysicianFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PathologyLabFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PathologyLab" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "phoneNumber" } },
          { kind: "Field", name: { kind: "Name", value: "faxNumber" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "city" } },
          { kind: "Field", name: { kind: "Name", value: "state" } },
          { kind: "Field", name: { kind: "Name", value: "zipCode" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "skipFax" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "LdtOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "LdtUploadedFileConnectionFields",
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "createdByCs" } },
          { kind: "Field", name: { kind: "Name", value: "orderingPathway" } },
          { kind: "Field", name: { kind: "Name", value: "positiveCores" } },
          { kind: "Field", name: { kind: "Name", value: "totalCores" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientStatusAtBiopsy" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientDischargeDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customPrimaryDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "metastaticDiagnosisCodes" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "customMetastaticDiagnosisCode" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "consentToBillPatient" },
          },
          { kind: "Field", name: { kind: "Name", value: "trfS3Url" } },
          { kind: "Field", name: { kind: "Name", value: "hasRevisedReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasAiReport" } },
          { kind: "Field", name: { kind: "Name", value: "hasBillingHold" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "labProcedureDatePhi" },
          },
          { kind: "Field", name: { kind: "Name", value: "qcRevisionReason" } },
          { kind: "Field", name: { kind: "Name", value: "slideSamplePart" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patientLabAccession" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "imageQcRejectionReason" },
          },
          { kind: "Field", name: { kind: "Name", value: "specimenId" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkAccession" } },
          { kind: "Field", name: { kind: "Name", value: "bxlinkEncounterId" } },
          { kind: "Field", name: { kind: "Name", value: "organizationName" } },
          { kind: "Field", name: { kind: "Name", value: "labType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mostRecentPathologyTrrFax" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FaxFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "orderingProvider" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrderingProviderFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pathologyLab" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PathologyLabFields" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LdtRejectReportMutation,
  LdtRejectReportMutationVariables
>;
export const BuildVersionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "BuildVersions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "buildVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BuildVersionsFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BuildVersionsFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BuildVersions" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "ui" } },
          { kind: "Field", name: { kind: "Name", value: "backend" } },
          { kind: "Field", name: { kind: "Name", value: "slidePreprocessor" } },
          { kind: "Field", name: { kind: "Name", value: "aiExecutor" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "prostatePrognosticModel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "breastPrognosticModel" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "prostateSTADTModel" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BuildVersionsQuery, BuildVersionsQueryVariables>;
export const SamdOrdersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SamdOrders" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "perPage" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchText" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ShortString" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortBy" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "SortBy" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "seq" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Seq" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "statuses" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OrderStatus" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "specimenTypes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SpecimenType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "orders" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "perPage" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "perPage" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchText" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchText" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortBy" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortBy" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "seq" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "seq" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "statuses" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "statuses" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "specimenTypes" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "specimenTypes" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "page" } },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "SamdOrderListItemFields",
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderListItemFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SamdOrdersQuery, SamdOrdersQueryVariables>;
export const SamdOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SamdOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "order" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "orderId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SamdOrderDetailFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "nStage" } },
          { kind: "Field", name: { kind: "Name", value: "tumorSize" } },
          { kind: "Field", name: { kind: "Name", value: "patientAge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRejectionReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportCustomRejectionReason" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SamdOrderQuery, SamdOrderQueryVariables>;
export const CreateSamdOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSamdOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "order" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "order" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SamdOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "nStage" } },
          { kind: "Field", name: { kind: "Name", value: "tumorSize" } },
          { kind: "Field", name: { kind: "Name", value: "patientAge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRejectionReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportCustomRejectionReason" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSamdOrderMutation,
  CreateSamdOrderMutationVariables
>;
export const UpdateSamdOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateSamdOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "order" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "order" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SamdOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "nStage" } },
          { kind: "Field", name: { kind: "Name", value: "tumorSize" } },
          { kind: "Field", name: { kind: "Name", value: "patientAge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRejectionReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportCustomRejectionReason" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSamdOrderMutation,
  UpdateSamdOrderMutationVariables
>;
export const SubmitSamdOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitSamdOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SubmitOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SamdOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "nStage" } },
          { kind: "Field", name: { kind: "Name", value: "tumorSize" } },
          { kind: "Field", name: { kind: "Name", value: "patientAge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRejectionReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportCustomRejectionReason" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitSamdOrderMutation,
  SubmitSamdOrderMutationVariables
>;
export const ResubmitSamdOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ResubmitSamdOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ResubmitOrderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resubmitOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "SamdOrderDetailFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "PatientBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Patient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "firstNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "lastNamePhi" } },
          { kind: "Field", name: { kind: "Name", value: "dateOfBirthPhi" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "filename" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "progress" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "uploaderAuth0Id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UploadedFileConnectionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "UploadedFileConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UploadedFileFields" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrderBaseFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "crossOrgId" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "submittedAt" } },
          { kind: "Field", name: { kind: "Name", value: "statusUpdatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "creatorAuth0Id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "specimenType" } },
          { kind: "Field", name: { kind: "Name", value: "nccnRiskCategory" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primaryGleasonScore" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondaryGleasonScore" },
          },
          { kind: "Field", name: { kind: "Name", value: "psa" } },
          { kind: "Field", name: { kind: "Name", value: "tStage" } },
          { kind: "Field", name: { kind: "Name", value: "surgicalMargin" } },
          { kind: "Field", name: { kind: "Name", value: "statusMessage" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "patient" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "PatientBaseFields" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "uploadedFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UploadedFileConnectionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SamdOrderDetailFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Order" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "OrderBaseFields" },
          },
          { kind: "Field", name: { kind: "Name", value: "nStage" } },
          { kind: "Field", name: { kind: "Name", value: "tumorSize" } },
          { kind: "Field", name: { kind: "Name", value: "patientAge" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportRejectionReason" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reportCustomRejectionReason" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResubmitSamdOrderMutation,
  ResubmitSamdOrderMutationVariables
>;
export const DeleteSamdOrderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteSamdOrder" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOrder" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "order" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSamdOrderMutation,
  DeleteSamdOrderMutationVariables
>;
export const DownloadTrrDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadTRR" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "signed" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadTRR" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "signed" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "signed" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "TestResultReport" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presignedUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DownloadReportError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DownloadTrrQuery, DownloadTrrQueryVariables>;
export const DownloadSlideImageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadSlideImage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "fileDownloadUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadSlideImageQuery,
  DownloadSlideImageQueryVariables
>;
export const DownloadClinicalDecisionSupportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadClinicalDecisionSupport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadClinicalDecisionSupport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "ClinicalDecisionSupport" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presignedUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DownloadReportError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadClinicalDecisionSupportQuery,
  DownloadClinicalDecisionSupportQueryVariables
>;
export const DownloadCombinedReportDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "DownloadCombinedReport" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadCombinedReport" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CombinedReport" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "presignedUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "DownloadReportError" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadCombinedReportQuery,
  DownloadCombinedReportQueryVariables
>;
export const CreateSamdMultipartUploadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateSamdMultipartUpload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filename" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UploadedFileCategory" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "orderId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "countParts" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "scannerType" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SlideImageScannerType" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createMultipartUpload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "filename" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "filename" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "orderId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "orderId" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "countParts" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "countParts" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "scannerType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "scannerType" },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "uploadedFile" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateSamdMultipartUploadMutation,
  CreateSamdMultipartUploadMutationVariables
>;
